export const VOUCHER_RESTRICTION_TOOLTIP_MESSAGE =
  'Your selected award does not qualify for this restriction';
